import { render, staticRenderFns } from "./IconHandShake.vue?vue&type=template&id=b2a7691e&"
import script from "./IconHandShake.vue?vue&type=script&lang=ts&"
export * from "./IconHandShake.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports